module.exports = "/assets/5dec9ba39c2ea70dfc22e826b72fda02.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/M7.png
// module id = 2728
// module chunks = 0